module.exports = __webpack_public_path__ + "static/media/Preguntas.f9243180.jpg";